import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import { putJson } from 'utils/fetch';
import { hideLoader } from 'plugins/loader';
import Simulation from './Simulation';
import SchedulingModal from './SchedulingModal';
import { displayConfirmModalIfRequired } from 'plugins/confirm-action';
import handleStudy from '../study';
import moment from 'moment';

const changeInterventionFirstDateVisibility = isReorg => {
  const hasCustomGlobalFrequency =
    $('div.globalIntervention').is(':visible') &&
    $('input[name="global_configuration.intervention_frequency"]').val() ===
      'CUSTOM';

  const interventionStartDateInput = $('#intervention_start_date');
  const interventionStartDateField = interventionStartDateInput.parent(
    '.field'
  );

  const hasAllCustomSiteFrequency =
    $('div.multiSiteIntervention').is(':visible') &&
    $('input[name^="site_configuration"]')
      .filter('[name$=".intervention_frequency"]')
      .filter((index, elt) => {
        return $(elt).val() !== 'CUSTOM';
      }).length === 0;

  if (hasCustomGlobalFrequency || hasAllCustomSiteFrequency) {
    interventionStartDateInput.addClass('disabled');
    if (isReorg) {
      interventionStartDateField.removeClass('required');
    }
  } else {
    interventionStartDateInput.removeClass('disabled');
    if (isReorg) {
      interventionStartDateField.addClass('required');
    }
  }
};

function handleInterventionChoice($form) {
  const $intervention = $form.find('div.intervention');
  const $frequency = $intervention.find(
    `input[name='global_configuration.intervention_frequency']`
  );
  const $buttons = $intervention.find('button.singleSite');
  const isReorg = $('#intervention_start_date')
    .parent('.field')
    .hasClass('required');

  $buttons.each(function() {
    const button = $(this);
    button.on('click', evt => {
      evt.preventDefault();
      $frequency.val(button.val());
      $buttons.removeClass('active');
      button.addClass('active');
      changeInterventionFirstDateVisibility(isReorg);
    });
  });
}

function handleMultiSiteInterventionChoice($form) {
  const $intervention = $form.find('div.intervention');
  const $buttons = $intervention.find('button.multiSite');
  const isReorg = $('#intervention_start_date')
    .parent('.field')
    .hasClass('required');

  $buttons.each((index, element) => {
    const siteId = $(element).data('id');
    const inputSelector = $(
      `input[name='site_configuration[${siteId}].intervention_frequency']`
    );

    $(element).on('click', evt => {
      const $frequency = $intervention.find(inputSelector);

      $frequency.val($(element).val());
      $intervention
        .find(`button.multiSite[data-id='${siteId}']`)
        .removeClass('active');
      $(element).addClass('active');
      changeInterventionFirstDateVisibility(isReorg);
    });
  });

  const $customButtons = $intervention.find(
    'button.multiSite.modalMultiSiteInterventionPickerPlanification'
  );

  $customButtons.each((index, element) => {
    const siteId = $(element).data('id');
    const siteName = $(element).data('name');

    const inputSelector = `input[name='site_configuration[${siteId}].intervention_custom_frequency']`;
    const $div = $(element).closest('div.intervention');
    const $input = $div.find(inputSelector);

    const root = document.getElementById('custom-frequency-root');

    const onModalClosed = () => ReactDOM.unmountComponentAtNode(root);

    const onSelectionSaved = selection => {
      onModalClosed();

      const result = selection
        .map(e => {
          const interNumber = e.inter_number || 1;
          return (e.date + ',').repeat(interNumber);
        })
        .reduce(function(a, b) {
          return a + ',' + b;
        }, '');
      $input.val(result);
    };

    const startMonth = moment().startOf('month');

    const startScope = startMonth.startOf('isoweek').isSame(startMonth, 'month')
      ? startMonth.startOf('isoweek')
      : startMonth.startOf('isoweek').plus(1, 'isoweek');

    const endScope = moment()
      .day('Monday')
      .startOf('month')
      .add(1, 'year')
      .endOf('month');

    if ($input.val().length > 0) {
      const initialValue = $input.val().split(',');

      const scoped = initialValue
        .filter(date =>
          moment(date, 'DD/MM/YYYY').isBetween(startScope, endScope)
        )
        .reduce(function(a, b) {
          return a + ',' + b;
        }, '');

      $input.val(scoped);
    }

    $(element).on('click', evt => {
      evt.preventDefault();
      let value = [];

      //With empty initial value
      if ($input.val() && $input.val().length > 0) {
        value = $input.val().split(',');
      }

      // Rendering scheduling modal

      const modalTitle = siteName
        ? `Pré Planification (${siteName})`
        : `Pré Planification`;
      ReactDOM.render(
        <SchedulingModal
          title={modalTitle}
          value={value}
          onSaved={onSelectionSaved}
          onClosed={onModalClosed}
          multiIntervention={true}
        />,
        root
      );
    });
  });
}

function handleInvoiceChoice($form) {
  const $invoice = $form.find('div.invoice');
  const $frequency = $invoice.find('input[name=invoice_frequency]');
  const $buttons = $invoice.find('button');

  $buttons.each(function() {
    const button = $(this);
    button.on('click', evt => {
      evt.preventDefault();
      $frequency.val(button.val());
      $buttons.removeClass('active');
      button.addClass('active');
    });
  });
}

function handleInterventionCheckbox($form) {
  const $checkbox = $form.find('#multi_site_organisation');

  const $globalIntervention = $form.find('.globalIntervention');
  const $multiSiteintervention = $form.find('.multiSiteIntervention');

  const $globalInterventionFrequency = $globalIntervention.find(
    "input[name^='global_configuration']"
  );
  const $multiSiteInterventionFrequency = $multiSiteintervention.find(
    "input[name^='site_configuration']"
  );

  $checkbox.on('change', evt => {
    evt.preventDefault();
    if ($checkbox.is(':checked')) {
      $globalIntervention.hide();
      $multiSiteintervention.show();
      $globalInterventionFrequency.attr('disabled', 'disabled');
      $multiSiteInterventionFrequency.removeAttr('disabled');
      $checkbox.val('true');
    } else {
      $multiSiteintervention.hide();
      $globalIntervention.show();
      $multiSiteInterventionFrequency.attr('disabled', 'disabled');
      $globalInterventionFrequency.removeAttr('disabled');
      $checkbox.val('false');
    }
  });

  if ($checkbox.val() === 'true') {
    $globalIntervention.hide();
    $multiSiteintervention.show();
    $globalInterventionFrequency.attr('disabled', 'disabled');
    $multiSiteInterventionFrequency.removeAttr('disabled');
  } else {
    $multiSiteintervention.hide();
    $globalIntervention.show();
    $multiSiteInterventionFrequency.attr('disabled', 'disabled');
    $globalInterventionFrequency.removeAttr('disabled');
  }
}

function handleInvoiceCheckbox($form) {
  const $invoice = $form.find('div.invoice');
  const $estimateReminder = $form.find('div.estimateReminder');
  const $checkbox = $form.find('#invoice_enabled');
  const $invoiceFrequency = $invoice.find('input[name=invoice_frequency]');

  $checkbox.on('change', evt => {
    evt.preventDefault();
    if ($checkbox.is(':checked')) {
      $invoice.show();
      $estimateReminder.show();
      $invoiceFrequency.removeAttr('disabled');
      $checkbox.val('true');
    } else {
      $invoice.hide();
      $estimateReminder.hide();
      $invoiceFrequency.attr('disabled', 'disabled');
      $checkbox.val('false');
    }
  });

  if ($checkbox.val() === 'true') {
    $invoice.show();
    $estimateReminder.show();
    $invoiceFrequency.removeAttr('disabled');
  } else {
    $invoice.hide();
    $estimateReminder.hide();
    $invoiceFrequency.attr('disabled', 'disabled');
  }
}

function handleAutomaticInvoiceCheckbox($form) {
  const $invoice = $form.find('div.invoice');
  const $checkbox = $form.find('#automatic_invoice_enabled');
  const $byIntervention = $invoice.find('button[value=INTERVENTION]');
  const $oneShot = $invoice.find('button[value=ONESHOT]');

  $checkbox.on('change', evt => {
    evt.preventDefault();
    if ($checkbox.is(':checked')) {
      $checkbox.val('true');
      $byIntervention.attr('disabled', 'disabled');
      if ($byIntervention.hasClass('active')) {
        $byIntervention.removeClass('active');
        $oneShot.trigger('click');
      }
    } else {
      $checkbox.val('false');
      $byIntervention.removeAttr('disabled');
    }
  });

  if ($checkbox.val() === 'true') {
    $byIntervention.attr('disabled', 'disabled');
  } else {
    $byIntervention.removeAttr('disabled');
  }
}

let nextAction;

const handleButtonSimulation = () => {
  $('#runSimulation').on('click', evt => {
    const $button = $(evt.target);
    const action = $button.attr('data-action');

    nextAction = action;

    return true;
  });
};

function handleForm($form) {
  $form.on('submit', evt => {
    const $button = $(document.activeElement);
    const action = $button.attr('data-action') || nextAction;

    nextAction = null;

    if (action) {
      evt.preventDefault();

      const $form = $(evt.currentTarget);
      const data = {};

      for (let prop of $form.serializeArray()) {
        data[prop.name] = prop.value;
      }

      putJson(action, JSON.stringify(data)).then(
        res => {
          hideLoader();
          const line = ReactDOMServer.renderToStaticMarkup(
            <Simulation
              data={res}
              invoiceDate={data.invoice_date}
              interventionStartDate={data.intervention_start_date}
            />
          );
          $('#simulation').html(line);
        },
        err => {
          hideLoader();
          console.log(err);
          $('#simulation').html('');
        }
      );
    }
  });
}

function initCustomFrequency(
  buttonSelector,
  divSelector,
  inputSelector,
  title,
  multiIntervention
) {
  const $button = $(buttonSelector);
  const $div = $button.closest(divSelector);
  const $input = $div.find(inputSelector);

  const root = document.getElementById('custom-frequency-root');

  const onModalClosed = () => ReactDOM.unmountComponentAtNode(root);

  const onSelectionSaved = selection => {
    onModalClosed();

    const result = selection
      .map(e => {
        const interNumber = e.inter_number || 1;
        return (e.date + ',').repeat(interNumber);
      })
      .reduce(function(a, b) {
        return a + ',' + b;
      }, '');
    $input.val(result);
  };

  const startMonth = moment().startOf('month');

  const startScope = startMonth.startOf('isoweek').isSame(startMonth, 'month')
    ? startMonth.startOf('isoweek')
    : startMonth.startOf('isoweek').plus(1, 'isoweek');

  const endScope = moment()
    .day('Monday')
    .startOf('month')
    .add(1, 'year')
    .endOf('month');

  if ($input.val().length > 0) {
    const initialValue = $input.val().split(',');

    const scoped = initialValue
      .filter(date =>
        moment(date, 'DD/MM/YYYY').isBetween(startScope, endScope)
      )
      .reduce((a, b) => {
        return a + ',' + b;
      }, '');

    $input.val(scoped);
  }

  $button.on('click', evt => {
    evt.preventDefault();
    let value = [];

    //With empty initial value
    if ($input.val().length > 0) {
      value = $input.val().split(',');
    }

    // Rendering scheduling modal
    ReactDOM.render(
      <SchedulingModal
        title={title}
        value={value}
        onSaved={onSelectionSaved}
        onClosed={onModalClosed}
        multiIntervention={multiIntervention}
      />,
      root
    );
  });
}

function handleEstimateSelectionChange($form) {
  const $dropdown = $form.find('select[name=estimate_reference]');
  const lastEstimateInfo = $form.find('.lastEstimateInfo');
  const estimateInfos = $form.find('.estimateInfo');

  $dropdown.on('change', evt => {
    const $select = evt.target;
    const currentValue = $select.options[$select.selectedIndex].value;

    lastEstimateInfo.hide();
    estimateInfos.hide();

    const $estimateToShow = estimateInfos.filter(
      (index, element) => !element.dataset.id.localeCompare(currentValue)
    );
    $estimateToShow.show();
  });
}

function initDefaultInterventionFrequencies($form) {
  $form.find('div.multiSiteFrequency').each((index, element) => {
    const isInitialised = $(element).find('button.active').length;

    if (!isInitialised) {
      const id = $(element).find('button.multiSite')[0].dataset.id;

      const frequencyInputValue = $form.find(
        `input[name="site_configuration[${id}].intervention_frequency"]`
      ).value;
      const customFrequencyInputValue = $form.find(
        `input[name="site_configuration[${id}].intervention_custom_frequency"]`
      ).value;

      if (!frequencyInputValue && !customFrequencyInputValue) {
        $form
          .find(
            `input[name="site_configuration[${id}].intervention_frequency"]`
          )
          .val('WEEKLY');
        $(element)
          .find('button.multiSite[value="WEEKLY"]')
          .addClass('active');
      }
    }
  });

  $form.find('div.globalFrequency').each((index, element) => {
    const isInitialised = $(element).find('button.active').length;
    const frequencyInputValue = $form.find(
      'input[name="global_configuration.intervention_frequency"]'
    ).value;
    const customFrequencyInputValue = $form.find(
      'input[name="global_configuration.intervention_custom_frequency"]'
    ).value;

    if (!isInitialised && !frequencyInputValue && !customFrequencyInputValue) {
      $form
        .find('input[name="global_configuration.intervention_frequency"]')
        .val('WEEKLY');
      $form.find('button.singleSite[value="WEEKLY"]').addClass('active');
    }
  });
}

export const handleStartDate = $form => {
  const $delayField = $form.find('input[name="end_date_delay"]');
  const $startDateField = $form.find('input[name="start_date"]');
  const $endDateField = $form.find('input[name="end_date"]');

  if (
    $delayField &&
    $delayField.length &&
    $startDateField &&
    $startDateField.length &&
    $endDateField &&
    $endDateField.length
  ) {
    $startDateField.on('change', evt => {
      if ($delayField.val() === 'ONE_YEAR') {
        const oneYearLater = moment(evt.target.value, 'DD/MM/YYYY')
          .add(1, 'year')
          .subtract(1, 'days')
          .format('DD/MM/YYYY');
        $endDateField.val(oneYearLater);
      }
    });

    $delayField.on('change', evt => {
      if (evt.target.value === 'ONE_YEAR') {
        if ($startDateField.val() && $startDateField.val().length) {
          const oneYearLater = moment($startDateField.val(), 'DD/MM/YYYY')
            .add(1, 'year')
            .subtract(1, 'days')
            .format('DD/MM/YYYY');
          $endDateField.val(oneYearLater);
        }
        $endDateField.parent('.field').addClass('disabled');
      } else {
        $endDateField.parent('.field').removeClass('disabled');
      }
    });
  }
};

export const edit = () => {
  const $form = $('form');

  initDefaultInterventionFrequencies($form);
  handleInterventionChoice($form);
  handleInvoiceChoice($form);
  handleAutomaticInvoiceCheckbox($form);
  handleInvoiceCheckbox($form);
  handleInterventionCheckbox($form);
  handleStartDate($form);
  initCustomFrequency(
    'button.modalInvoicePickerPlanification',
    'div.invoice',
    'input[name=invoice_custom_frequency]',
    'Frequence de facturation',
    false
  );
  initCustomFrequency(
    'button.modalInterventionPickerPlanification',
    'div.intervention',
    'input[name="global_configuration.intervention_custom_frequency"]',
    'Pré Planification',
    true
  );
  handleInterventionCheckbox($form);
  handleMultiSiteInterventionChoice($form);
  handleEstimateSelectionChange($form);

  const $button = $('button[data-id=save-organize]');
  $button.on('click', evt => {
    evt.preventDefault();
    // Handling confirm action modal
    displayConfirmModalIfRequired($button, () => $form.submit());
  });

  const isReorg = $('#intervention_start_date')
    .parent('.field')
    .hasClass('required');

  if (isReorg) {
    const $id = $form.data('id');
    const $seeStudyButton = $('#bt-see-study');
    $seeStudyButton.hide();
    handleStudy($id);
  } else {
    const $planStudyButton = $('#bt-schedule-study');
    $planStudyButton.hide();
  }

  handleForm($form);
  handleButtonSimulation();
  changeInterventionFirstDateVisibility(isReorg);
};



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/organize/index.js